import dayjs from 'dayjs';
import advanced from 'dayjs/plugin/advancedFormat';
import dur from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { CONFIG } from '@/infra/config';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);
dayjs.extend(dur);

dayjs.tz.setDefault(CONFIG.TIME_ZONE);

export enum TimeUnit {
    MS = 'milliseconds',
    SEC = 'seconds',
    MIN = 'minutes',
    HR = 'hours',
    MONTH = 'months',
    WEEK = 'weeks',
    DAY = 'days',
    YR = 'years',
}

export type ZonedDateTime = dayjs.Dayjs;

export const isZonedDateTime = dayjs.isDayjs;

export const zoneddatetime = (value: dayjs.ConfigType) => {
    return dayjs(value).tz(CONFIG.TIME_ZONE);
};

export const now = () => {
    return dayjs().tz(CONFIG.TIME_ZONE);
};

export const today = () => {
    return now().startOf(TimeUnit.DAY);
};

export const getExpiredTime = (ttl: number, unit = TimeUnit.HR) => {
    return now().add(ttl, unit).toDate();
};

export const parse = (value: string) => {
    console.log('parse:', zoneddatetime(value));
    if (!value || value.length == 0) return;
    return zoneddatetime(value);
};

export const format = (
    value: ZonedDateTime,
    format: string = 'YYYY/MM/DD HH:mm:ss'
) => {
    if (!value) return '';
    return value.format(format);
};

export const to = (value: string | ZonedDateTime, unit?: TimeUnit) => {
    const diff = zoneddatetime(value).diff(now(), unit);
    return dayjs.utc(diff);
};

export const from = (value: string | ZonedDateTime, unit?: TimeUnit) => {
    const diff = now().diff(zoneddatetime(value), unit);
    return dayjs.utc(diff);
};

export const countdown = (value: number, unit: TimeUnit) => {
    const ms = dayjs.duration(value, unit).asMilliseconds();
    return dayjs.utc(ms);
};

export const convert = (value: number, unit: TimeUnit, as: TimeUnit) => {
    return dayjs.duration(value, unit).as(as);
};

export const diffInMonths = (start: ZonedDateTime, end: ZonedDateTime) => {
    return end.diff(start, TimeUnit.MONTH);
};

export const isValid = (value: string | ZonedDateTime) => {
    return zoneddatetime(value).isValid();
};

export default {
    zoneddatetime,
    isZonedDateTime,
    now,
    today,
    getExpiredTime,
    parse,
    format,
    from,
    to,
    countdown,
    convert,
    diffInMonths,
};
